import styles from './EmptyValue.module.scss';

export const EmptyValue = () => <span className={styles.empty}>–</span>;
